import { createModel } from "nyax";
import { JobQueue } from "src/models/jobQueue";
import { createItemsEntityModel } from "src/store/itemsEntity";

export const JobQueueEntityModel = createModel(
  class extends createItemsEntityModel<JobQueue>((item) => item.id) {
    public selectors() {
      return {
        ...super.selectors(),
      };
    }
  }
);
